'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    useToolbarToggleButtonBase_unstable: function() {
        return useToolbarToggleButtonBase_unstable;
    },
    useToolbarToggleButton_unstable: function() {
        return useToolbarToggleButton_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactbutton = require("@fluentui/react-button");
const _ToolbarContext = require("../Toolbar/ToolbarContext");
const useToolbarToggleButton_unstable = (props, ref)=>{
    const state = useToolbarToggleButtonBase_unstable(props, ref);
    return {
        appearance: 'subtle',
        ...state
    };
};
const useToolbarToggleButtonBase_unstable = (props, ref)=>{
    const handleToggleButton = (0, _ToolbarContext.useToolbarContext_unstable)((ctx)=>ctx.handleToggleButton);
    const checked = (0, _ToolbarContext.useToolbarContext_unstable)((ctx)=>{
        var _ctx_checkedValues_props_name;
        return !!((_ctx_checkedValues_props_name = ctx.checkedValues[props.name]) === null || _ctx_checkedValues_props_name === void 0 ? void 0 : _ctx_checkedValues_props_name.includes(props.value));
    });
    const { onClick: onClickOriginal } = props;
    const toggleButtonState = (0, _reactbutton.useToggleButton_unstable)({
        checked,
        ...props
    }, ref);
    const state = {
        ...toggleButtonState,
        name: props.name,
        value: props.value
    };
    const handleOnClick = (e)=>{
        if (state.disabled || state.disabledFocusable) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        handleToggleButton === null || handleToggleButton === void 0 ? void 0 : handleToggleButton(e, state.name, state.value, state.checked);
        onClickOriginal === null || onClickOriginal === void 0 ? void 0 : onClickOriginal(e);
    };
    state.root.onClick = handleOnClick;
    return state;
};
